import axios from 'axios';
import lscache from 'lscache';
import LRUCache from 'lru-cache';
import lzString from 'lz-string';
import md5 from 'md5';
var storageCaching = function (cache, maxAge) {
    return function (config) {
        if (!config.useCache) {
            return axios.defaults.adapter(config);
        }
        var responsePromise;
        var duration = config.maxAge ? config.maxAge : maxAge;
        var storageKey = md5(config.url);
        var cachedResponse = cache.get(storageKey);
        if (cachedResponse) {
            responsePromise = Promise.resolve(JSON.parse(lzString.decompress(cachedResponse)));
        }
        else {
            responsePromise = axios.defaults.adapter(config);
            responsePromise.then(function (resp) {
                cache.set(storageKey, lzString.compress(JSON.stringify({ data: resp.data })), duration);
            });
        }
        return responsePromise;
    };
};
var axiosCachingAdapter = function (maxAge, key) {
    var cache;
    if (lscache.supported()) {
        cache = lscache;
        if (key) {
            cache.setBucket(md5(key));
        }
        // @ts-ignore
        cache.setExpiryMilliseconds(1);
    }
    else {
        cache = new LRUCache();
    }
    return storageCaching(cache, maxAge);
};
export default axiosCachingAdapter;
//# sourceMappingURL=axiosCachingAdapter.js.map